import { ref } from 'vue'
import { getProductGuide } from '@/constants/productGuides'
import { hasSeenGuide, markGuideSeen } from '@/utils/productGuideStorage'

/**
 * @param {import('vue').Ref<string | number | null | undefined> | (() => string | number | null | undefined)} userIdSource
 */
export function useProductGuide(userIdSource) {
  const show = ref(false)
  const activeGuideId = ref('')
  const isAutoSession = ref(false)

  function resolveUserId() {
    const src = userIdSource
    if (typeof src === 'function') return src()
    return src?.value ?? src
  }

  function openGuide(guideId, { auto = false } = {}) {
    if (!getProductGuide(guideId)) return
    activeGuideId.value = guideId
    isAutoSession.value = auto
    show.value = true
  }

  function tryAutoShow(guideId) {
    const userId = resolveUserId()
    if (!userId || !guideId) return
    if (hasSeenGuide(userId, guideId)) return
    openGuide(guideId, { auto: true })
  }

  function persistAutoSeen() {
    const userId = resolveUserId()
    if (isAutoSession.value && userId && activeGuideId.value) {
      markGuideSeen(userId, activeGuideId.value)
    }
  }

  function confirmGuide() {
    persistAutoSeen()
    show.value = false
    isAutoSession.value = false
  }

  function dismissGuide() {
    // Авто-показ: закрытие крестиком/Esc тоже считается просмотром — не показывать снова.
    persistAutoSeen()
    show.value = false
    isAutoSession.value = false
  }

  return {
    show,
    activeGuideId,
    openGuide,
    tryAutoShow,
    confirmGuide,
    dismissGuide,
  }
}
